import { mpsEndpoints } from '../mps/mps-endpoints';

export const environment = {
  production: false,
  envName: 'dev',
  api: {
    host: 'https://api-d.mycontractorpp.alzp.tgscloud.net',
    providers: mpsEndpoints.providers,
  },
  loaderOnHttp: true,
  defaultLocale: 'fr',
  allowedLanguage: ['fr', 'en'],
  appName: 'MyContractor',
  mpsIcons: ['bin', 'edit', 'gray-edit', 'user', 'info', 'pdf', 'pdf-file', 'three-dots', 'account-circle', 'search'],
  appIcons: [],
  translationsSource: 'local',
  allowImpersonation: false,
  /** URL du formulaire ServiceNow pour un offboarding urgent (départ le jour même). */
  serviceNowUrgentOffboardingUrl: 'https://totalenergies.service-now.com/sp?id=sc_home', // TODO: replace with the definitive URL once confirmed by the client
};
